<template>
    <b-card class="mb-5">
        <h3>{{$route.name}}</h3>
        <b-breadcrumb>
            <b-breadcrumb-item><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item>
            <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
        </b-breadcrumb>
        <hr>
        <b-row>
            <b-col md="12">
                <b-row class="mt-1 mb-2">
                    <b-col md="3 mb-2">
                        <date-picker v-model="tableFilter.date" type="date" range placeholder="Date Range"></date-picker>
                    </b-col>
                    <b-col md="3 mb-2">
                        <b-form-input :placeholder="'Plate'" v-model="tableFilter.search_plate" customQueryParamName="search" />
                    </b-col>
                    <b-col md="3 mb-2">
                        <b-form-select v-model="tableFilter.branch" :options="branchList" />
                    </b-col>
                    <b-col md="3 mb-2">
                        <typeahead ref="technicianTypeahead" :preventAutofocus="false" :labelFields="['firstName', 'lastName']" :placeholder="'Requested By'" :urlSearch="apiUrl.profile" arr-response="profile" :model="tableFilter.userRequestedBy" v-on:afterHit="doFilter" customQueryParamName="search" />
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <paginated-table ref="dataTable" :can-delete="false" :can-edit="false" :can-approve="false" :can-reject="false" :data-url="apiUrl.vehicleRequest" :data-key="dataKey" :data-columns="columns" :data-params="['requestedBy', 'start_time', 'end_time', 'search_plate', 'requested_by', 'branch_uuid']">
        </paginated-table>
    </b-card>
</template>
<script>
    import PaginatedTable from '@/components/PaginatedTable'
    import DatePicker from 'vue2-datepicker'
    import 'vue2-datepicker/index.css'
    import Typeahead from '@/components/Typeahead'
    export default {
        name: 'vehicle-report',
        components: {
            PaginatedTable,
            DatePicker,
            Typeahead
        },
        data () {
            return {
                dataKey: 'vehicleRequest',
                apiUrl: {
                    profile : window.AppConfig.apiUrl + 'profile',
                    branch : window.AppConfig.apiUrl + 'branch',
                    vehicleRequest : window.AppConfig.apiUrl + 'vehicle-request'
                },
                columns: [
                    {
                        key: 'vehiclePlate',
                        label: 'Plate',
                        sortable: true
                    },
                    {
                        key: 'vehicle',
                        label: 'Vehicle',
                        sortable: true
                    },
                    {
                        key: 'requestedByEmployee',
                        label: 'Requested By',
                        sortable: true
                    },
                    {
                        key: 'startTime',
                        label: 'Start',
                        sortable: true
                    },
                    {
                        key: 'endTime',
                        label: 'End',
                        sortable: true
                    },
                    {
                        key: 'startPhoto',
                        label: 'Start Photo',
                        sortable: true
                    },
                    {
                        key: 'finishPhoto',
                        label: 'Finish Photo',
                        sortable: true
                    },
                    {
                        key: 'createdAt',
                        label: 'Created',
                        sortable: true
                    },
                    {
                        key: 'actions',
                        label: ''
                    }
                ],
                tableFilter: {
                    branch_uuid: this.$route.query.branch_uuid,
                    branch: null,
                    requested_by: this.$route.query.requested_by,
                    date: null,
                    start_time: this.$route.query.start_time,
                    end_time: this.$route.query.end_time,
                    search_plate: this.$route.query.search_plate,
                    userRequestedBy: {
                        value: null
                    }
                },
                branchList: [
                    {
                        value: null,
                        text: 'Branch'
                    }
                ]
            }
        },
        watch: {
            'fakeTableFilter.requestedBy' (value) {
                this.tableFilter.requestedBy = value ? 1 : null
                this.doFilter()
            },
            'tableFilter.date' (value) {
                if (value.length >= 1 && value[0] === null && value[1] === null) {
                    this.tableFilter.date = null
                    this.doFilter()
                } else {
                    this.doFilter()
                }
            },
            'tableFilter.search_plate' () {
                this.doFilter()
            },
            'tableFilter.branch' () {
                this.doFilter()
            },
        },
        mounted () {
            this.getBranch()
        },
        methods: {
            doFilter () {
                this.tableFilter.requested_by = this.tableFilter.userRequestedBy.value
                this.tableFilter.search_plate = this.tableFilter.search_plate !== '' ? this.tableFilter.search_plate : null
                this.tableFilter.branch_uuid = this.tableFilter.branch
                this.tableFilter.start_time = this.tableFilter.date !== null ? this.$moment(this.tableFilter.date[0]).format('YYYY-MM-DD') : null
                this.tableFilter.end_time = this.tableFilter.date !== null ? this.$moment(this.tableFilter.date[1]).format('YYYY-MM-DD') : null
                this.$refs.dataTable.doFilter(this.tableFilter)
            },
            getBranch () {
                this.$http.get(this.apiUrl.branch + '?limit=10000').then(resp => {
                    resp.data._embedded.branch.forEach(data => {
                        this.branchList.push({
                            value: data.uuid,
                            text: data.name
                        })
                    })
                })
            },
            getDateTime (value) {
                if (value !== null) {
                    return this.$moment(value).format('YYYY-MM-DD hh:mm a')
                } else {
                    return '-'
                }
            },
            reset () {
                this.tableFilter.requestedBy = null
            }
        }
    }
</script>